/** The pressable inside a Field that holds a picker: a Select's trigger
 *  button or a combobox's input. */
export const PICKER_CONTROL_SELECTOR = "button, input";

/** The editable surface inside a Field that holds a rich-text editor. Named
 *  precisely, because the editor's toolbar buttons precede it in the DOM. */
export const EDITOR_CONTROL_SELECTOR = '[contenteditable="true"]';

/**
 * Moves focus into the first Field whose answer is still missing, so a
 * blocked submit lands the user on the thing to fix. Each entry is the
 * Field's root element (null before mount), the control selector inside it,
 * and whether it is currently invalid; the first invalid one wins.
 */
export function focusFirstInvalid(
  entries: ReadonlyArray<{
    root: HTMLElement | null;
    selector: string;
    invalid: boolean;
  }>,
): void {
  const target = entries.find((entry) => entry.invalid);
  target?.root?.querySelector<HTMLElement>(target.selector)?.focus();
}
